function isPlainObject(value) {
    return (
        value !== null && 
        typeof value === 'object' && 
        !Array.isArray(value) && 
        Object.getPrototypeOf(value) === Object.prototype
    );
}

export function deepMerge(base, override) {
    if (override === undefined) return base;

    if (Array.isArray(base) || Array.isArray(override)) {
        return override;
    }

    if (isPlainObject(base) && isPlainObject(override)) {
        const result = { ...base };
        for (const key of Object.keys(override)) {
            result[key] = key in base ? deepMerge(base[key], override[key]) : override[key];
        }
        return result;
    }

    return override;
}